import React from 'react';

// components
import Sidemenu from '../components/sidemenu';

class ManagementLayout extends React.Component {
  constructor(props) {
      super(props);
  }
  render() {
    const menu1 = [
      {label: 'Messages', link: '/inbox'},
      {label: 'Contacts', link: '#'},
      {label: 'Settings', link: '#'},
    ]
    const menu2 = [
      {label: 'Property', link: '#'},
      {label: 'Invoice', link: '#'},
      {label: 'Renter', link: '#'},
      {label: 'Applicants', link: '/applicants'}
    ]
    return (
        <div className="container frame">
        <div className="row">
          <div className="col-md-3">
            <Sidemenu title="Manage" menu={menu1}/>
            <Sidemenu title="Property" menu={menu2}/>
          </div>
            {this.props.children}
        </div>
      </div>
      )
  }
}

export default ManagementLayout;